import * as React from "react";
import { useContext }  from "react";
import { AiFillPlayCircle } from "react-icons/ai";
import logo from "images/logo.png";
import logo_me from "images/logo_me.png";
import State from "images/state.svg";
import { shortenAddress } from '../utils/shortenAddress'
import { RewardManagementContext } from '../context/RewardManagementContext';

const Navbar = () => {

  const { connectWallet, currentAccount } = useContext(RewardManagementContext);

  return (
    <nav className="w-full flex pl-10  justify-between items-center p-4">
      <div className="md:felx[0.5] flex-initial justify-left items-left">
      <img src={logo_me} alt="logo" className="w-20 cursor-pointer" />
      </div>

      <div className="flex md:justify-right md:item-right p-4">

      {/* {!currentAccount && (
            <button
              type="button"
              onClick={connectWallet}
              className="flex flex-row justify-center items-center my-5 bg-[#2952e3] p-3 rounded-full cursor-pointer hover:bg-[#2546bd]"
            >
              <AiFillPlayCircle className="text-white mr-2" />
              <p className="text-white text-base font-semibold">
                Connect Wallet
              </p>
            </button>
          )} */}
      {/* <a className="btn" style={{"height" : "35px", "width" : "180px"}} href="#" onClick={connectWallet}><span>Connect to wallet</span></a> */}
          
      {!currentAccount ?
      <a className="btn" style={{"height" : "35px", "width" : "180px"}} href="#" onClick={connectWallet}><span>Connect to wallet</span></a>
      :<span className="btn" style={{"height" : "35px", "width" : "180px"}}><span>{shortenAddress(currentAccount)}</span></span>       
      }
      </div>
    </nav>
  );
};
export default Navbar;
